export const isBirthday = value => {
  return /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/.test(value)
}

export const isValidName = value => {
  return /\s/.test(value)
}

export const hasSpecialChars = value => {
  return /[`!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/.test(value)
}

export const isValidZipcode = (value, vm) => {
  const nlZipcode = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
  const beZipcode = /^[0-9]{4}$/i
  const deZipcode = /^[0-9]{5}$/i
  if (!vm || value === '') { return false }
  if (vm.country === 'NL') { return nlZipcode.test(value) }
  if (vm.country === 'DE') { return deZipcode.test(value) }
  if (vm.country === 'BE') { return beZipcode.test(value) }
  return 1
}
